

// For a full list of available options, check the node_modules/bootstrap/js/src directory. These likely are accurate,
// as they don't change often.

// Import everything
// import * as bootstrap from "bootstrap";

// Or selectively import
// import 'bootstrap/js/dist/alert';
// import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/scrollspy';
// import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

import {ready} from "@leap/leapies";
// import Swiper bundle with all modules installed

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';



// Example
ready(() => {

    const materialSwiper = new Swiper('.materialSwiper',{
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        }
    )
});
